export const hseSiteConfig: any = {
  id: 'hse',
  name: 'Hospital Español',
  institutionName: 'HOSPITAL ESPAÑOL',
  branding: {
    logo: 'assets/hse/logo.svg',
    favicon: 'assets/hse/favicon.ico',
  },
  social: {
    facebook: 'https://www.facebook.com/hospitalespanolrosario/',
    instagram: 'https://www.instagram.com/hospitalespanolrosario/',
    youtube: 'https://www.youtube.com/@hospitalespanolrosario',
  },
  contact: {
    address: 'Mitre 3151<br />Rosario - Santa Fe<br />Argentina',
    phone: '',
    mapsUrl: '',
  },
  navigation: {
    portalPacienteUrl: 'https://he.amr.org.ar/pacientes/',
    services: [
      {
        label: 'Guardias 24 hs.',
        url: 'https://he.amr.org.ar/servicios/guardias-las-24-hs/',
      },
      {
        label: 'Consultorios Externos',
        url: 'https://he.amr.org.ar/pacientes/consultorios-externos/',
      },
      { label: 'Internación', url: 'https://he.amr.org.ar/servicios/internacion/' },

      { label: 'Imágenes', url: 'https://he.amr.org.ar/servicios/imagenes/' },

      { label: 'Laboratorio', url: 'https://he.amr.org.ar/servicios/laboratorio-y-analisis/' },

      {
        label: 'Centro Materno Infantil / Ginecología',
        url: 'https://he.amr.org.ar/centro-materno-infantil/',
      },

      { label: 'Rehabilitación', url: 'https://he.amr.org.ar/cuerpo-profesional/fisiatria/' },

      { label: 'Anatomía Patológica', url: 'https://he.amr.org.ar/servicios/anatomia-patologica/' },

      { label: 'Microbiología', url: 'https://he.amr.org.ar/servicios/microbiologia/' },

      { label: 'Banco de Sangre', url: 'https://he.amr.org.ar/servicios/banco-de-sangre/' },

      { label: 'Hospital de Día', url: 'https://he.amr.org.ar/servicios/hospital-de-dia/' },

      { label: 'Hemodinamia', url: 'https://he.amr.org.ar/hemodinamia/' },

      { label: 'Diálisis', url: 'https://he.amr.org.ar/hemodinamia/' },
    ],
    institutionMenuLabel: 'EL HOSPITAL',
    institucion: [
      {
        label: 'Residencias Hospital Español',
        url: 'https://he.amr.org.ar/residencias-hospital-espanol/',
      },
      { label: 'Ubicación', url: 'https://he.amr.org.ar/ubicacion/' },
      {
        label: 'Accesos a Bloques',
        url: 'https://he.amr.org.ar/ubicacion/',
      },
      {
        label: 'Sobre el Hospital',
        url: 'https://he.amr.org.ar/sobre-el-hospital/',
      },
      {
        label: 'Sumate al Español',
        url: 'https://www.amr.org.ar/cargatucv/#/login',
      },
    ],
    cuerpoProfesionalUrl: 'https://he.amr.org.ar/cuerpo-profesional/',
  },
  legal: {
    terms: {
      title: { prefix: 'Términos y', highlight: 'Condiciones' },
      content: `HSE`,
    },
    privacy: {
      title: { prefix: 'Políticas de', highlight: 'Privacidad' },
      content: `HSE`,
    },
  },
  footer: {
    administrativeHours:
      'Lunes a Viernes de 5 a 20 hs.<br />Sábados de 6 a 13 hs.<br />Domingos de 6 a 13 hs.',
    emergencyText: 'Ingreso por Gaboto 1141.<br />Las 24 hs.',
  },
};
